module.exports = {
  realm: 'DS',
  market: 'de-CH',
  domain: 'weightwatchers.ch',
  countryId: '30000',
  vsPath: 'ch/de',
  spiceLocale: 'de-ch',
  vsUrl: 'https://www{env}weightwatchers.com/ch/de',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/de-ch/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.ch/',
  currency: 'Fr.',
  decimalSeparator: '.',
  thousandSeparator: '',
  currencyFormat: 'Fr. %number ',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.ch/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.ch/v2/login/',
  countryCode: 'CH',
  commUlr: 'https://commerce{env}weightwatchers.com/ch/de/api/',
  timezone1: 'Europe/Zurich',
  timezone2: '+01:00',
};
